import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import HeroSection from "@/components/landing/HeroSection";
import PainPointsSection from "@/components/landing/PainPointsSection";
import SolutionSection from "@/components/landing/SolutionSection";
import FeaturesSection from "@/components/landing/FeaturesSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import PricingSection from "@/components/landing/PricingSection";
import FAQSection from "@/components/landing/FAQSection";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";
import LegalModals from "@/components/landing/LegalModals";
import { TermosPage, PrivacidadePage } from "@/components/landing/LegalPages";

function LandingPage() {
  const [activeModal, setActiveModal] = useState(null);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <PainPointsSection />
        <SolutionSection />
        <FeaturesSection />
        <TestimonialsSection />
        <PricingSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer onOpenModal={setActiveModal} />
      <WhatsAppButton />
      <LegalModals activeModal={activeModal} onClose={() => setActiveModal(null)} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App" data-testid="app-container">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/termos" element={<TermosPage />} />
          <Route path="/privacidade" element={<PrivacidadePage />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
